import React, { useMemo } from 'react';
import { useWatch, Control } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { PayoutsForm } from '@/modules/onboarding/model/payoutsStep';
import { FRPartnerType } from '@/modules/partner/model/partnerType';
import { SelectField } from '@src-common/view/adapters/reactHookForm/SelectField';
import { TextField } from '@src-common/view/adapters/reactHookForm/TextField';

type Props = {
  control: Control<PayoutsForm>;
};

const FrPaymentType: React.FC<Props> = ({ control }) => {
  const intl = useIntl();

  const partnerTypes = useMemo(
    () => [
      {
        title: intl.formatMessage({
          defaultMessage: 'Pay myself',
          id: '6Sy04Z',
          description: 'Payout type option title - Pay myself',
        }),
        value: FRPartnerType.selfEmployed,
      },
      {
        title: intl.formatMessage({
          defaultMessage: 'Pay my company',
          id: 'Ar+x4C',
          description: 'Payout type option title - Pay my company',
        }),
        value: FRPartnerType.company,
      },
    ],
    [intl],
  );

  const selectedPartnerType = useWatch({ control, name: 'partnerType' });

  return (
    <>
      <SelectField
        control={control}
        name="partnerType"
        title={intl.formatMessage({
          defaultMessage: 'PAYOUT TYPE',
          id: 'MafFrv',
          description: 'PAYOUT TYPE field title',
        })}
        items={partnerTypes}
      />

      {selectedPartnerType === FRPartnerType.company && (
        <>
          <TextField
            shouldUnregister={true}
            name="companyName"
            control={control}
            title={intl.formatMessage({
              defaultMessage: 'COMPANY NAME',
              id: 'w8qpaR',
              description: 'COMPANY NAME field title',
            })}
          />

          <TextField
            shouldUnregister={true}
            name="companyAddress"
            control={control}
            title={intl.formatMessage({
              defaultMessage: 'COMPANY ADDRESS',
              id: 'jfwv8e',
              description: 'COMPANY ADDRESS field title',
            })}
          />

          <TextField
            shouldUnregister={true}
            name="vatRegNo"
            control={control}
            title={intl.formatMessage({
              defaultMessage: 'VAT REG NO',
              id: '9u8nc2',
              description: 'VAT REG NO field title',
            })}
            rules={{
              pattern: {
                value: /^(FR)?\d{9,12}$/,
                message: intl.formatMessage({
                  defaultMessage: "This is 9-12 digits, sometimes with 'FR' at the start.",
                  id: 'ouhUeY',
                  description: 'field error message',
                }),
              },
            }}
            description={intl.formatMessage({
              defaultMessage: "Optional. This is 9-12 digits, sometimes with 'FR' at the start.",
              id: 'Q2FGy/',
              description: 'field description',
            })}
          />
        </>
      )}
    </>
  );
};

export { FrPaymentType };
